import { useMutation } from "@tanstack/react-query";
import type { FormEvent } from "react";
import { useState } from "react";

import { api } from "../../shared/api/client";
import { image } from "../../shared/assets/manifest";
import { Button } from "../../shared/ui/Button";
import { Field } from "../../shared/ui/Field";
import { errorMessage, useToast } from "../../shared/ui/ToastProvider";

export function RegisterPage() {
  const toast = useToast();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const register = useMutation({
    mutationFn: (payload: Record<string, string>) =>
      api("/api/public/orgs/register", { method: "POST", body: JSON.stringify(payload) }),
    onSuccess: () => {
      setError("");
      setSuccess("注册成功，即将返回登录页");
      toast("注册成功", "success");
      window.setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    },
    onError: (err) => {
      const message = errorMessage(err, "注册失败");
      setSuccess("");
      setError(message);
      toast(message, "error");
    }
  });

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const password = String(form.get("password") || "");
    if (password !== String(form.get("confirmPassword") || "")) {
      setSuccess("");
      setError("两次输入的密码不一致");
      return;
    }
    register.mutate({
      orgName: String(form.get("orgName") || "").trim(),
      adminName: String(form.get("adminName") || "").trim(),
      username: String(form.get("username") || "").trim(),
      password
    });
  };

  return (
    <main className="auth-page">
      <section className="auth-hero">
        <div className="auth-title-row">
          <img src={image.star} alt="" />
          <div>
            <h1>班级积分管理系统</h1>
            <p>创建学校、班级和老师账号</p>
          </div>
        </div>
        <ol className="auth-steps" aria-label="注册流程">
          <li className="auth-step active">
            <strong>1</strong>
            <span>填写机构信息</span>
          </li>
          <li className="auth-step">
            <strong>2</strong>
            <span>创建管理员</span>
          </li>
          <li className="auth-step">
            <strong>3</strong>
            <span>进入班级系统</span>
          </li>
        </ol>
        <img className="auth-scene" src={image.garden} alt="" />
      </section>
      <section className="auth-panel">
        <img
          className="auth-panel-mascot"
          src={image.dockBunny}
          alt=""
          aria-hidden="true"
        />
        <h2>注册新机构</h2>
        <p className="setting-desc">注册成功后，老师就可以进入班级给同学加星。</p>
        <form className="form-stack" onSubmit={onSubmit}>
          <Field label="机构名称">
            <input name="orgName" maxLength={80} required />
          </Field>
          <Field label="管理员姓名">
            <input name="adminName" maxLength={30} required />
          </Field>
          <Field label="登录账号">
            <input name="username" maxLength={40} autoComplete="username" required />
          </Field>
          <Field label="密码">
            <input name="password" type="password" minLength={8} autoComplete="new-password" required />
          </Field>
          <Field label="确认密码">
            <input name="confirmPassword" type="password" minLength={8} autoComplete="new-password" required />
          </Field>
          {error ? <div className="inline-error">{error}</div> : null}
          {success ? <div className="inline-success">{success}</div> : null}
          <Button variant="primary" type="submit" disabled={register.isPending}>
            注册
          </Button>
          <a className="form-link" href="/">
            已有账号？返回登录
          </a>
        </form>
      </section>
    </main>
  );
}
